// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jhS1DMHqSYPLMxjzki4r {
    padding: 4px 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/admin/import/interest_imports/components/boundary.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB","sourcesContent":[".boundary {\n    padding: 4px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boundary": `jhS1DMHqSYPLMxjzki4r`
};
export default ___CSS_LOADER_EXPORT___;
